import React, { useContext, RefObject } from 'react';

export const { PlayerViewProvider, usePlayerViewRef } = (() => {
    const context = React.createContext<RefObject<HTMLDivElement> | null>(null);

    return {
        PlayerViewProvider: context.Provider,
        usePlayerViewRef: () => useContext(context),
    };
})();
